import * as api from '@/http'

export const ActionSetEntities = async ({ commit }) => {
  const entities = await api.http.get('dash/entities').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_entities', entities)
}
